export default __webpack_public_path__ + "static/media/coffee-shop-animals.84f72fe2.png";